import React, { useContext, useMemo, useState } from 'react';
import styles from '../../styles/cr.module.scss';
import { ISpecificEntityFormProps, EntityValidations, IZCoreUserGroup, ZCoreUserGroup, ZCoreUserGroupMember } from '../../types';
import { DataContext } from '../DataContext';
import { CrTextField } from '../cr/CrTextField';
import { EntityForm } from '../EntityForm';
import { CrUserPicker } from '../cr/CrUserPicker';

class ZCoreUserGroupValidations extends EntityValidations {
    public Username: string = null;
    public EmailAddress: string = null;
    public Password: string = null;
    public AuthenticationType = null;
}

export const ZCoreUserGroupForm = (props: ISpecificEntityFormProps): React.ReactElement => {
    const { dataServices: { zCoreUserGroupService, zCoreUserGroupMemberService }, lookupData, loadLookupData: { users: { all: allUsers } } } = useContext(DataContext);
    useMemo(() => allUsers(), [allUsers]);

    const validateEntity = async (userGroup: IZCoreUserGroup): Promise<ZCoreUserGroupValidations> => {
        const errors = new ZCoreUserGroupValidations();

        if (userGroup.Title == null || userGroup.Title === '') {
            errors.Title = 'Group name is required';
            errors.Valid = false;
        }
        else {
            errors.Title = null;
        }

        return errors;
    };


    return (
        <EntityForm<IZCoreUserGroup, ZCoreUserGroupValidations>
            {...props}
            entityName="User Group"
            renderFormFields={({ changeTextField, changeMultiUserPicker }, formState) => {
                const { FormData: userGroup, ValidationErrors: errors } = formState;

                return (
                    <div>
                        <CrTextField
                            label="Group name"
                            className={styles.formField}
                            required={true}
                            maxLength={255}
                            value={userGroup.Title}
                            onChange={(ev, newValue) => changeTextField(newValue, 'Title')}
                            errorMessage={errors.Title}
                        />

                        <CrUserPicker
                            label="Members(s)"
                            className={styles.formField}
                            users={lookupData.Users?.All}
                            itemLimit={50}
                            //required={true}
                            //errorMessage={errors.Owners}
                            selectedUsers={userGroup.ZCoreUserGroupMembers?.map(u => u.UserID)}
                            onChange={v => changeMultiUserPicker(v, 'ZCoreUserGroupMembers', new ZCoreUserGroupMember(), 'UserID')}
                        />

                    </div>
                );
            }}
            loadEntity={(id) => {
                //console.log('in load');
                return zCoreUserGroupService.read(id, true, true);
            }}
            loadNewEntity={() => new ZCoreUserGroup()}
            loadEntityValidations={() => new ZCoreUserGroupValidations()}
            onValidateEntity={validateEntity}
            onCreate={ug => zCoreUserGroupService.create(ug)}
            onUpdate={ug => zCoreUserGroupService.update(ug.ID, ug)}
            childEntities={[
                {
                    ObjectParentProperty: 'ZCoreUserGroupMembers',
                    ParentIdProperty: 'ZCoreUserGroupID',
                    ChildIdProperty: 'UserID',
                    ChildService: zCoreUserGroupMemberService
                },
            ]}
        />
    );
};
